module.exports = __webpack_public_path__ + "static/media/filter-icon.0aeb16d2.svg";